import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { PdpSharedDetail } from './PdpSharedDetail';
import { PdpSharedConditionModalLoader } from '../PdpSharedModals/PdpSharedConditionModal/PdpSharedConditionModalLoader';
import { FormattedMessage } from 'react-intl';
import tracking from 'dibs-tracking';

const openConditionModal = (event, setModalOpen) => {
    if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
    }

    tracking.trackEvent({
        category: 'product',
        action: 'view condition descriptions clicked',
    });

    setModalOpen(true);
};

export const PdpSharedDetailCondition = props => {
    const [modalOpen, setModalOpen] = useState(false);

    const { detailValues, currency, delimiter, itemId, relay } = props;
    return (
        <>
            <PdpSharedDetail
                detailValues={detailValues}
                currency={currency}
                delimiter={delimiter}
            />
            <div>
                <a
                    onClick={e => openConditionModal(e, setModalOpen)}
                    data-tn="open-condition-modal"
                >
                    <FormattedMessage
                        id="pdpSharedDetailCondition.conditionModalLink"
                        defaultMessage="See Condition Descriptions"
                    />
                </a>
                <div>
                    <PdpSharedConditionModalLoader
                        isOpen={modalOpen}
                        onClose={() => setModalOpen(false)}
                        environment={relay.environment}
                        itemId={itemId}
                    />
                </div>
            </div>
        </>
    );
};

PdpSharedDetailCondition.propTypes = {
    detailValues: PropTypes.array,
    delimiter: PropTypes.string,
    currency: PropTypes.string,
    relay: PropTypes.object.isRequired,
    itemId: PropTypes.string.isRequired,
};
